import React, { Component } from "react";
import voiceStore from "../../stores/voiceStore";
import moment from "moment";
import Rating from "react-rating";
import {
  FaEdit,
  FaRegStar,
  FaStar,
  FaStarHalfAlt,
  FaTimes,
} from "react-icons/fa";
import Wave from "../../components/Wave";
import { observer } from "mobx-react";
import Button from "../../components/Button";
import { LuPlay, LuPlaySquare } from "react-icons/lu";
import generalStore from "../../stores/generalStore";

const TalentDetails = observer(
  class TalentDetails extends Component {
    constructor(props) {
      super(props);
      this.state = {
        showMore: false,
      };
    }

    toggleShowMore = () => {
      this.setState((prevState) => ({ showMore: !prevState.showMore }));
    };

    calculateAge = (date) => {
      const birthDate = moment(date);
      const today = moment();
      return today.diff(birthDate, "years");
    };

    async componentDidMount() {
      this.setState({ user: voiceStore.talent });

      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    handleKeyDown = (event) => {
      if (event.key === "Escape") {
        voiceStore.setTalentDetailsModalVisible(false);
      }
    };

    renderTags = (tags) => {
      return tags
        .filter((tag) => tag.trim() !== "")
        .join(",")
        .split(",")
        .map((tag) => tag.trim())
        .filter((tag) => tag !== "")
        .map((tag) => (
          <span
            key={tag}
            className="font-extralight text-xs lg:text-xs text-[#21272A] p-1 bg-[#DEDFE3] rounded-md px-1"
          >
            {tag}
          </span>
        ));
    };

    render() {
      const { user, showMore } = this.state;
      return (
        <>
          {user ? (
            <div className="fixed inset-0 flex flex-col items-center lg:pt-16 bg-black bg-opacity-50 z-[51]  ">
              <div className="flex flex-col relative overflow-scroll w-full lg:w-[85%] h-full lg:h-[90%]  py-6 px-5 lg:px-10 overflow-y-scroll overflow-x-hidden bg-white shadow-lg">
                <div className="flex lg:w-full flex-col my-6  items-center z-10">
                  <div className="flex flex-1 flex-col lg:flex-row items-center text-center lg:items-start lg:text-start">
                    <div className="flex flex-row items-center gap-6">
                      {user.ProfileImgPath ? (
                        <img
                          src={
                            process.env.REACT_APP_BASE_URL +
                            "/" +
                            user.ProfileImgPath
                          }
                          className="w-[100px] h-[100px] rounded-full"
                          alt={user?.TalentName}
                        ></img>
                      ) : (
                        <div className="w-[100px] h-[100px] rounded-full bg-gray-200 flex justify-center items-center text-2xl text-black/50 select-none">
                          {generalStore.getInitials(user.TalentName)}
                        </div>
                      )}
                    </div>
                    <div className="w-[1px] h-2/3 bg-[#DDE1E6] mx-12"></div>

                    <div className="flex flex-1 flex-col ">
                      <div className="flex flex-row justify-center items-center gap-x-6">
                        <span className="text-4xl font-semibold text-[#21272A] mb-2">
                          {user.TalentName ? user.TalentName : "-"}
                        </span>
                        <button
                          onClick={() => {
                            voiceStore.setUpdateTalentDetailsModalVisible(true);
                            voiceStore.setTalentDetailsModalVisible(false);
                          }}
                          className="text-xl text-[#F89A1F] flex gap-2 items-center"
                        >
                          <span className="text-base">Edit Profile</span>
                          <FaEdit />
                        </button>
                      </div>
                      <span className="text-base font-normal text-[#21272A]">
                        Mobile : {user.MobileNo ? user.MobileNo : "-"}
                      </span>
                      <span className="text-base font-normal text-[#21272A]">
                        E-mail :{" "}
                        {user.Email ? (
                          <a
                            href={`mailto:${user.Email}`}
                            className="hover:underline"
                          >
                            {user.Email}
                          </a>
                        ) : (
                          "-"
                        )}
                      </span>

                      {showMore && (
                        <>
                          <span className="text-base font-normal text-[#21272A]">
                            Age : {user.Age ? this.calculateAge(user.Age) : "-"}
                          </span>
                          <span className="text-base font-normal text-[#21272A]">
                            Social Accounts :{" "}
                            {user.SocialAccounts ? user.SocialAccounts : "-"}
                          </span>
                          <span className="text-base font-normal text-[#21272A]">
                            Nationality :{" "}
                            {user.Nationality ? user.Nationality : "-"}
                          </span>
                          <span className="text-base font-normal text-[#21272A]">
                            Accents :{" "}
                            {user.Accents
                              ? user.Accents !== ""
                                ? user.Accents
                                : "-"
                              : "-"}
                          </span>
                          <span className="text-base font-normal text-[#21272A]">
                            Notes : {user.Notes ? user.Notes : "-"}
                          </span>
                          <div className="flex flex-row justify-center items-center lg:justify-start">
                            <span className="text-base font-normal text-[#21272A]">
                              Rating :{" "}
                            </span>
                            <Rating
                              className="mt-[2px] ml-[2px]"
                              emptySymbol={<FaRegStar size={15} />}
                              fullSymbol={<FaStar size={15} />}
                              halfSymbol={<FaStarHalfAlt size={15} />}
                              fractions={2}
                              readonly
                              initialRating={user.Rating ? user.Rating : 0}
                            />
                          </div>
                          <span className="text-base font-normal text-[#21272A]">
                            Fee : {user.Fee ? user.Fee : "-"}
                          </span>
                        </>
                      )}
                      <button
                        onClick={this.toggleShowMore}
                        className="text-base text-[#F89A1F] mt-2"
                      >
                        {showMore ? "Show Less Details" : "Show More Details"}
                      </button>
                    </div>
                  </div>

                  
                  {user.voice_data.length <= 0 && (
                    <div className="flex flex-col items-center justify-center mt-12">
                      <span className="text-xl font-semibold text-[#21272A]">
                        No voice data uploaded
                      </span>

                      <Button
                        onClick={() => {
                          voiceStore.setUpdateTalentVoicesModalVisible(true);
                          voiceStore.setTalentDetailsModalVisible(false);
                        }}
                        className="mt-4"
                        title="Add New"
                      ></Button>
                    </div>
                  )}

                  {/* Voice Data Table */}
                  {user.voice_data?.length > 0 && (
                    <div className="mt-6 flex flex-1 flex-col w-full">
                      {user.voice_data?.length > 0 && (
                        <div className="flex flex-1 relative flex-row bg-[#F2F4F8] p-4 justify-between border border-[#DDE1E6]">
                          <span className="flex flex-[0.3] font-normal text-sm text-[#121619] justify-center">
                            Name
                          </span>
                          <span className="hidden lg:flex flex-[0.2] font-normal text-sm text-[#121619] justify-center">
                            Voice Samples
                          </span>
                          <span className="flex flex-[0.5] font-normal text-sm text-[#121619] justify-center">
                            Tags
                          </span>
                          <button
                            onClick={() => {
                              voiceStore.setUpdateTalentVoicesModalVisible(
                                true
                              );
                              voiceStore.setTalentDetailsModalVisible(false);
                            }}
                            className="text-xl text-[#F89A1F] flex gap-2 items-center"
                          >
                            <span className="text-base">Edit Sample & Tags</span>
                            <FaEdit />
                          </button>
                        </div>
                      )}

                      {user.voice_data?.map((file, index) => (
                        <div
                          onClick={() => {
                            if (file.fileType === "mp4") {
                              voiceStore.setCurrentVoice(null);
                              voiceStore.setVideoModal({
                                fileName: file.fileName,
                                video:
                                  process.env.REACT_APP_BASE_URL +
                                  "/" +
                                  file.voice_path,
                              });
                            } else {
                              voiceStore.setCurrentVoice(null);

                              setTimeout(() => {
                                voiceStore.setCurrentVoice({
                                  talent_id: user.TalentId,
                                  talent_name: user.TalentName,
                                  voice_path:
                                    process.env.REACT_APP_BASE_URL +
                                    "/" +
                                    file.voice_path,
                                  voice_modulation_path:
                                    process.env.REACT_APP_BASE_URL +
                                    "/" +
                                    file.voice_modulation_path,
                                  sample_id: file.sample_id,
                                  IsFavorite: file.isFavorite,
                                  profile_image_path: user.ProfileImgPath,
                                });

                                voiceStore.togglePlayPause(true);
                              }, 500);
                            }
                          }}
                          key={index}
                          className="flex flex-row p-4 justify-between cursor-pointer items-center border border-[#DDE1E6]"
                        >
                          {file.fileType !== "mp4" && (
                            <button
                              onClick={() => {
                                voiceStore.setCurrentVoice(null);

                                setTimeout(() => {
                                  voiceStore.setCurrentVoice({
                                    talent_id: user.TalentId,
                                    talent_name: user.TalentName,
                                    voice_path:
                                      process.env.REACT_APP_BASE_URL +
                                      "/" +
                                      file.voice_path,
                                    voice_modulation_path:
                                      process.env.REACT_APP_BASE_URL +
                                      "/" +
                                      file.voice_modulation_path,
                                    sample_id: file.sample_id,
                                    IsFavorite: file.isFavorite,
                                    profile_image_path: user.ProfileImgPath,
                                  });
                                  console.log(voiceStore.currentVoice);
                                  

                                  voiceStore.togglePlayPause(true);
                                }, 500);
                              }}
                              className="mr-4"
                            >
                              <LuPlay size={20} color="black" />
                            </button>
                          )}
                          {file.fileType === "mp4" && (
                            <button
                              onClick={() => {
                                voiceStore.setCurrentVoice(null);
                                voiceStore.setVideoModal({
                                  fileName: file.fileName,
                                  video:
                                    process.env.REACT_APP_BASE_URL +
                                    "/" +
                                    file.voice_path,
                                });
                              }}
                              className="mr-4"
                            >
                              <LuPlaySquare size={20} color="black" />
                            </button>
                          )}

                          <div className="flex flex-[0.3] justify-between font-normal text-sm text-[#121619]">
                            <span className="font-normal text-sm text-[#21272A]">
                              {file.fileName}
                            </span>
                          </div>

                          {file.fileType !== "mp4" && (
                            <div className="hidden lg:flex flex-[0.2] flex-row justify-center font-normal text-sm text-[#121619] mr-3">
                              <Wave
                                clickable={false}
                                width={200}
                                audioUrl={
                                  process.env.REACT_APP_BASE_URL +
                                  "/" +
                                  file.voice_path
                                }
                                peaksUrl={
                                  process.env.REACT_APP_BASE_URL +
                                  "/" +
                                  file.voice_modulation_path
                                }
                                id={index}
                              />
                            </div>
                          )}
                          {file.fileType === "mp4" && (
                            <div className="hidden lg:flex flex-[0.2] flex-row justify-center font-normal text-sm text-[#121619] mr-3">
                              {" "}
                              Video{" "}
                            </div>
                          )}

                          <div className="flex flex-[0.5] flex-row justify-between font-normal text-sm text-[#121619] ml-4">
                            <div className="flex flex-1 flex-row flex-wrap gap-2">
                              {this.renderTags(file.tags.language)}
                              {this.renderTags(file.tags.gender)}
                              {this.renderTags(file.tags.accent)}
                              {this.renderTags(file.tags.style)}
                              {this.renderTags(file.tags.age)}
                              {this.renderTags(file.tags.additional_tags)}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  onClick={() => {
                    voiceStore.setTalentDetailsModalVisible(false);
                  }}
                  className="absolute right-5 top-4"
                >
                  <FaTimes size={20} color="black"></FaTimes>
                </button>
              </div>
            </div>
          ) : null}
        </>
      );
    }
  }
);

export default TalentDetails;
